// Import the zustand store instance
import dayjs from "dayjs";
import useQuoteStore from "../store/QuoteStore";
import { calculateRes } from "../../../shared/utils/calculateResidentYears";
import { formatDateT } from "../../../shared/utils/formatters";
import Occupation from "../../../shared/models/occupationModel";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { updateQuoteFields } from "../../../shared/utils/storeUtils";

const Tq3Mapper = {
  // Getter function to return the driver object from the store
  get() {
    const STATE = useAppStateStore.getState();
    // Get fresh data when getting values
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    const quote = useQuoteStore.getState().quote?.risk;
    const partTimeOccupation = driver?.occupations?.[1] ?? {};
    const vehicle = useQuoteStore.getState().quote?.risk?.vehicles?.[0] ?? {};
    const partTime = STATE.partTime;

    return {
      date: dayjs(quote?.startDate).isValid()
        ? dayjs(quote?.startDate).format("DD/MM/YYYY HH:mm")
        : null,
      coverLevel: vehicle.coverTypeId ? { value: vehicle.coverTypeId } : null,
      driverMaritalStatus: driver.maritalStatusId
        ? { value: driver.maritalStatusId }
        : null,
      DriverPartTime: driver.occupations?.[1] ? "Yes" : partTime,
      partTimeOccup: partTimeOccupation.occupationId
        ? { value: partTimeOccupation.occupationId }
        : null,
      partTimeBusinessOccupation: partTimeOccupation.employersBusinessId
        ? { value: partTimeOccupation.employersBusinessId }
        : null,
      parttimeempStatus: partTimeOccupation.employmentStatusId
        ? { value: partTimeOccupation.employmentStatusId }
        : null,
      driverOccupation: driver.occupations?.[0]?.occupationId
        ? { value: driver.occupations?.[0]?.occupationId }
        : null,
      empStatus: driver.occupations?.[0]?.employmentStatusId
        ? { value: driver.occupations?.[0]?.employmentStatusId }
        : null,

      DriverResidecy:
        driver.residentSinceBirth === null
          ? null
          : driver.residentSinceBirth
          ? "Yes"
          : "No",
      DriverYears:
        driver.ukResidenceYears === null ? null : driver.ukResidenceYears,
    };
  },

  // Setter function to update the driver data in the store
  set(data) {
    const STATE = useAppStateStore.getState();
    const setPartTime = STATE.setPartTime;
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    const partTimeOccupation = useQuoteStore.getState().quote?.risk
      ?.drivers?.[0].occupations[1];
    updateQuoteFields({
      "risk.startDate": formatDateT(data.date),
      "risk.vehicles.0.coverTypeId": data.coverLevel?.value,
      "risk.drivers.0.maritalStatusId": data.driverMaritalStatus?.value,
      "risk.drivers.0.occupations.0.employersBusinessId":
        data.BusinessOccupation?.value,
      "risk.drivers.0.occupations.0.employmentStatusId": data.empStatus?.value,
      "risk.drivers.0.occupations.0.occupationId": data.driverOccupation?.value,
      "risk.drivers.0.residentSinceBirth": data.DriverResidecy === "Yes",
      "risk.drivers.0.ukResidenceYears":
        data.DriverResidecy === "Yes"
          ? calculateRes(driver.dateOfBirth)
          : data.DriverYears,
    });
    setPartTime(data.DriverPartTime);
    if (data.DriverPartTime === "Yes") {
      updateQuoteFields({
        "risk.drivers.0.occupations.1": new Occupation(
          data.partTimeOccup?.value || null,
          data.parttimeempStatus?.value || null,
          data.partTimeBusinessOccupation?.value || null,
          true,
          null,
          null,
          0
        ),
      });
    } else if (partTimeOccupation) {
      const updatedOccupations = driver.occupations;
      if (updatedOccupations && updatedOccupations.length > 1) {
        const newOccupations = updatedOccupations.filter(
          (occupation) => occupation.partTime !== true
        );
        updateQuoteFields({
          "risk.drivers.0.occupations": newOccupations,
        });
      }
    }
  },
};

export default Tq3Mapper;
